import { render } from "./ProductCreditPrices.vue?vue&type=template&id=13d7f4ae"
import script from "./ProductCreditPrices.vue?vue&type=script&lang=js"
export * from "./ProductCreditPrices.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__